export default __webpack_public_path__ + "static/media/bike-storage.e0f60c9b.svg";